import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const accountingsSettingsRoutes: MenuInterface[] = [

    {
        code: 'GestionExercice_ViewModel',
        route: [
            {
                content: 'accounting/settings/exercise/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionJournaux_ViewModel',
        route: [
            {
                content: 'accounting/settings/journal/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionModeleEcheanciers_ViewModel',
        route: [
            {
                content: 'accounting/settings/schedule-models/list',
                focus: 'empty'
            },
            {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ]
    },
    {
        code: 'GestionParametrageComptes511_ViewModel',
        route: [
            {
                content: 'accounting/settings/waiting-accounts/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionParametrageSectionsAnalytique_ViewModel',
        route: [
            {
                content: 'accounting/settings/analytical-accounting/list',
                focus: 'empty'
            }, {primaryRoute: 'content', queryParams: {closeButton: 1}}
        ]
    },
    {
        code: 'GestionCaisseMono_VUP_ViewModel',
        route: [
            {
                content: 'accounting/settings/desk',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionCaisseMulti_VUP_ViewModel',
        route: [
            {
                content: 'accounting/settings/desks/list',
                focus: 'empty',
            }, {
                primaryRoute: 'content',
                queryParams:  {closeButton: 1}
            }
        ]
    },
    {
        code: 'GestionMoyenPaiement_ViewModel',
        route: [
            {
                content: 'accounting/settings/payment-methods/list',
                focus: 'empty',
            }, {primaryRoute: 'content', queryParams: {closeButton: 1}}
        ]
    },
    {
        code: 'GestionComptaClesRepartition_ViewModel',
        route: [
            {
                content: 'accounting/settings/analytical-accounting/distribution-keys/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'GestionComptaModeleSaisi_ViewModel',
        route: [
            {
                content: 'accounting/settings/entry-templates/list',
                focus: 'empty'
            }, {primaryRoute: 'content', queryParams: {closeButton: 1}}
        ]
    },
    {
        code: 'gestionCompte_ViewModel',
        route: [
            {
                content: 'accounting/settings/account-plan/list',
                focus: 'empty'
            }, {primaryRoute: 'content'}
        ]
    },
    {
        code: 'GestionCompteBancaireVUP_ViewModel',
        route: [
            {
                content: 'accounting/settings/bank-account/list',
                focus: 'empty'
            }, {primaryRoute: 'content', queryParams: {buttonClose: 1}}
        ]
    }
];
